<template>
	<nuxt-link
		v-if="article"
		:aria-label="article.content.title"
		:to="'/' + article.full_slug"
	>
		<div class="w-[60vw] shrink-0 space-y-sm md:w-auto lg:w-auto">
			<div v-if="article.content.image">
				<nuxt-picture
					:src="article.content.image.filename"
					class="aspect-video w-full"
					provider="storyblok"
					loading="lazy"
					sizes="xs:60vw md:240px lg:325px xl:411px 2xl:496px"
					:img-attrs="{
						class: 'aspect-video object-cover w-full h-full rounded-2xs',
					}"
					:alt="article.content.title"
				/>
			</div>

			<p class="font-prenton-cond text-2xl tracking-2xl xl:text-3xl">
				{{ article.content.title }}
			</p>

			<client-only>
				<div
					v-if="article.content?.ingress?.type === 'doc'"
					class="not-prose line-clamp-1 overflow-hidden text-sm leading-6 tracking-xl wrap-break-word text-ellipsis text-brand-dark-gray"
				>
					<sb-rich-text :document="article.content?.ingress" />
				</div>

				<p
					v-else
					class="line-clamp-1 overflow-hidden text-sm leading-6 tracking-xl text-ellipsis text-brand-dark-gray"
				>
					{{ article.content?.ingress }}
				</p>
			</client-only>
		</div>
	</nuxt-link>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "storyblok-js-client";

defineProps<{
	article: ISbStoryData;
}>();
</script>
